export default {
  bind(el, bind) {
    if (!bind.value) {
      return console.warn('No bind value passed to max ellipsis.');
    }

    const width = +bind.value;
    el.style.maxWidth = `${String(width)}px`;
    el.style.overflow = 'hidden';
    el.style.textOverflow = 'ellipsis';
    el.style.whiteSpace = 'nowrap';
    el.style.display = 'block'; // This is necessary.

    //@TODO, 22 Nov 18 Andrew P., evaluate if
    //below line is still needed.
    el.title = el.innerText;
  },
};
